import React from 'react';
import { Card } from './ui/card';

const SpendLessStack = () => {
  const steps = [
    {
      number: '1',
      title: 'Audit',
      description: 'Find where your money actually goes each month'
    },
    {
      number: '2',
      title: 'Eliminate',
      description: 'Cut spending that adds zero value to your life'
    },
    {
      number: '3',
      title: 'Replace',
      description: 'Swap expensive habits with better, cheaper alternatives'
    },
    {
      number: '4',
      title: 'Optimize',
      description: 'Build systems that save money automatically, forever'
    }
  ];

  return (
    <section className="py-20 px-6 bg-[#EBE6D8]">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-[#2C1810] mb-12 text-center">
          The SpendLess Stack
        </h2>
        
        <Card className="bg-[#F5F1E8] border-none shadow-lg p-8">
          <div className="space-y-6">
            {steps.map((step, index) => (
              <div key={index} className="flex gap-6 items-start">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 rounded-full bg-[#6B7A5C] text-white flex items-center justify-center font-bold text-lg">
                    {step.number}
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-[#2C1810] mb-2">
                    {step.title}
                  </h3>
                  <p className="text-[#5A5046] text-lg">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </section>
  );
};

export default SpendLessStack;